export { default } from './useIsFirstRender';

export type * from './types';
